import { checkIsAgent } from "shared-auth";
import { useTranslation } from "i18n";
import { FEATURE_FLAGS, useLaunchDarklyFlags } from "shared-services";
import { getAgenciesWithFilmmakersFromJWT } from "../../Organisms/AgenciesWithFilmmakersPopUp/getAgenciesWithFilmmakersFromJWT";
import ViewJobsOnFilmmakersButtonWrapper from ".";

const ViewJobsOnFilmmakersLeftHandNavItem = () => {
  const { agenciesWithFilmmakers } = getAgenciesWithFilmmakersFromJWT();
  const { t } = useTranslation();
  const {
    [FEATURE_FLAGS.FilmmakersSingleSignOn]: isFilmmakersSingleSignOnEnabled,
  } = useLaunchDarklyFlags([FEATURE_FLAGS.FilmmakersSingleSignOn]);

  const shouldShowViewJobsOnFilmmakersButton =
    agenciesWithFilmmakers.length > 0 &&
    agenciesWithFilmmakers?.filter((agency) => agency.FilmmakersAgencyId)
      .length > 0 &&
    isFilmmakersSingleSignOnEnabled &&
    checkIsAgent();

  return shouldShowViewJobsOnFilmmakersButton ? (
    <div className="text-s text-color-neutral-one hover:bg-grey-fog-1 focus:bg-grey-fog-1 relative flex h-[50px] w-full items-center gap-2.5 px-5 py-3 pl-[65px] font-normal before:absolute before:left-0 before:top-0 before:block before:h-full before:w-1 focus:underline focus:outline-none">
      <ViewJobsOnFilmmakersButtonWrapper
        agenciesWithFilmmakers={agenciesWithFilmmakers}
        title={t("common:nav.links.filmmakers.viewJobs")}
      />
    </div>
  ) : null;
};

export default ViewJobsOnFilmmakersLeftHandNavItem;
